import { useAppearance } from '@/hooks/use-appearance';
import { useSyncExternalStore } from 'react';

type ResolvedAppearance = 'light' | 'dark' | null;

function subscribe(onChange: () => void) {
    const observer = new MutationObserver(onChange);
    observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class'],
    });
    return () => observer.disconnect();
}

function getSnapshot(): ResolvedAppearance {
    return document.documentElement.classList.contains('dark')
        ? 'dark'
        : 'light';
}

// The document's theme is initialized before hydration. Keep the first React
// render identical to SSR, then read the resolved system or saved preference.
const getServerSnapshot = (): ResolvedAppearance => null;

export function useWelcomeAppearance() {
    const { updateAppearance } = useAppearance();
    const resolved = useSyncExternalStore(
        subscribe,
        getSnapshot,
        getServerSnapshot,
    );

    return {
        updateAppearance,
        resolved,
    };
}
